/* eslint-disable react-hooks/exhaustive-deps */
import { logEvent } from 'octiv-utilities/Functions';
import { useEffect } from 'react';

export default (params) => {
  const stringifiedParams = JSON.stringify(params);

  useEffect(() => logEvent(params), [stringifiedParams]);
};
